import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

interface Props {
  crumbMap?: {
    [title: string]: string
  },
}

const useStyles = makeStyles(theme =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexFlow: 'row',
    },
    crumb: {
      display: 'flex',
      textDecoration: 'none',
      fontFamily: 'raleway',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '13px',
      color: theme.palette.grey[700],
      cursor: 'default',
      '&:last-child': {
        fontWeight: 600,
      },
      '& span': {
        cursor: 'default',
        margin: theme.spacing(0, 0.5),
      }
    }
  }),
);

const BreadCrumb: React.FC<Props> = ({crumbMap}: Props) => {
  const classes = useStyles();
  const router = useHistory();
  const path = router.location.pathname;
  const breadCrumb = path.split('/').filter((item, index, arr) => 
    item !== '' && 
    item !== 'home' && 
    !/^[0-9]/.test(item) && 
    arr.indexOf(item) === index
  );

  return (
    <div className={classes.container}>
      {
        breadCrumb.map((crumb: any, index: any) => {
          const lastIndex = (index < breadCrumb.length - 1);
          return (
            <span key={index} className={classes.crumb}>
              {crumbMap ? (crumbMap[crumb] ?? crumb) : crumb}
              {lastIndex ? (<span> { '/' } </span>) : null }
            </span>
          )
        })
      }
    </div>
  );
}

export default BreadCrumb;
